module.exports = __webpack_public_path__ + "static/media/box-transfer.329bfef1.png";